'use strict';

var Layout = require('mag-component-layout');


/**
 * Render item function for tv channel list.
 *
 * @param {Element} $item - item to render
 * @param {Object} config - configuration of new data
 */
module.exports = function ( $item, config ) {
    var self = this,
        layout, index, item,
        layoutConfig;

    // clear inner content
    while ( $item.firstChild ) {
        $item.removeChild($item.firstChild);
    }

    for ( index = 0; index < config.items.length; index++ ) {
        item = config.items[index];
        if ( item && item.value instanceof HTMLElement ) {
            config.items[index] = item.value;
        }
    }

    layoutConfig = {
        focusable: false,
        data: config.items
    };

    if ( config.className ) {
        layoutConfig.className = config.className;
    }

    layout = new Layout(layoutConfig);

    $item.appendChild(layout.$node);
    $item.layout = layout;
    layout.parent = this;
    layout.$parentItem = $item;

    // focus layoutList if click on layout
    layout.addListener('click', function () {
        // add inner property to set that event comes from inner component
        self.emit('click:item', {$item: $item, inner: true});
    });

    if ( config.click ) {
        this.handlers[$item.index] = config.click;
    }
    // item is rendered
    $item.ready = true;

    $item.value = config.value;
};
